import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#FF4B55"
  }} d="M473.655,88.277H38.345c-18.486,0-33.914,13.084-37.537,30.495h510.386  C507.57,101.36,492.141,88.277,473.655,88.277z" /><path style={{
    fill: "#F5F5F5"
  }} d="M0.808,118.772C0.28,121.306,0,123.931,0,126.622v22.645h512v-22.645c0-2.69-0.28-5.315-0.808-7.85  H0.808z" /><rect y={149.26} style={{
    fill: "#FF4B55"
  }} width={512} height={30.495} /><rect y={179.76} style={{
    fill: "#F5F5F5"
  }} width={512} height={30.495} /><polygon style={{
    fill: "#FF4B55"
  }} points="0,229.518 8.826,229.518 8.828,240.754 512,240.754 512,210.258 0,210.258 " /><polygon style={{
    fill: "#F5F5F5"
  }} points="8.826,229.518 0,229.518 0,231.926 0,271.247 512,271.247 512,240.754 8.828,240.754 " /><rect y={271.25} style={{
    fill: "#FF4B55"
  }} width={512} height={30.495} /><rect y={301.74} style={{
    fill: "#F5F5F5"
  }} width={512} height={30.495} /><rect y={332.24} style={{
    fill: "#FF4B55"
  }} width={512} height={30.495} /><path style={{
    fill: "#F5F5F5"
  }} d="M0,385.38c0,2.69,0.28,5.315,0.807,7.849h510.386c0.527-2.535,0.807-5.159,0.807-7.849v-22.646H0  V385.38z" /><path style={{
    fill: "#FF4B55"
  }} d="M38.337,423.724h435.327c18.483-0.003,33.908-13.086,37.529-30.495H0.807  C4.429,410.638,19.853,423.721,38.337,423.724z" /><path style={{
    fill: "#41479B"
  }} d="M8.828,240.754h132.414c4.875,0,8.828-3.953,8.828-8.828V97.104c0-4.874-3.95-8.825-8.823-8.828  H38.345C17.167,88.277,0,105.444,0,126.622v105.304C0,236.801,3.953,240.754,8.828,240.754z" /><path style={{
    fill: "#F5F5F5"
  }} d="M72.512,127.737l-8.428,25.27l-26.638,0.206c-2.554,0.02-3.614,3.279-1.559,4.797l21.429,15.825  l-8.035,25.398c-0.77,2.435,2.003,4.45,4.081,2.965l21.674-15.489l21.672,15.49c2.078,1.485,4.851-0.53,4.081-2.965l-8.035-25.398  l21.429-15.825c2.055-1.517,0.995-4.778-1.559-4.797l-26.638-0.206l-8.428-25.27C76.748,125.314,73.321,125.314,72.512,127.737z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };